import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhoIsFor() {
  const isFor = ['Hombres de 20 a 30 años que sienten que la pornografía ha mermado su confianza.', "Estudiantes y profesionales que sufren de 'niebla mental' y falta de concentración.", 'Aquellos que han intentado dejarlo docenas de veces y siempre vuelven al mismo punto.', 'Hombres que quieren recuperar su deseo por la vida real y sus metas ambiciosas.'];
  const notFor = ["Quienes buscan una 'píldora mágica' sin hacer cambios en su entorno.", 'Personas que no están dispuestas a sacrificar 21 días de entretenimiento barato por una vida de mando.', 'Quienes aún se sienten cómodos en la autocompasión y la mediocridad.'];
  return <section className="py-20 px-6 bg-[#111113]" data-id="element-303">
      <div className="max-w-3xl mx-auto" data-id="element-304">
        <div className="grid sm:grid-cols-2 gap-8" data-id="element-305">
          <FadeIn data-id="element-306">
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 h-full" data-id="element-307">
              <h3 className="font-bebas text-3xl uppercase tracking-wide text-white mb-8 flex items-center gap-3" data-id="element-308">
                <div className="bg-amber-500/20 p-1.5 rounded-md" data-id="element-309">
                  <CheckIcon className="w-6 h-6 text-amber-500" data-id="element-310" />
                </div>
                Es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-311">
                {isFor.map((item, i) => <li key={i} className="flex gap-3 text-zinc-300" data-id="element-312">
                    <CheckIcon className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-313" />
                    <span className="leading-relaxed" data-id="element-314">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-315">
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 h-full" data-id="element-316">
              <h3 className="font-bebas text-3xl uppercase tracking-wide text-white mb-8 flex items-center gap-3" data-id="element-317">
                <div className="bg-red-500/10 p-1.5 rounded-md" data-id="element-318">
                  <XIcon className="w-6 h-6 text-red-500" data-id="element-319" />
                </div>
                No es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-320">
                {notFor.map((item, i) => <li key={i} className="flex gap-3 text-zinc-400" data-id="element-321">
                    <XIcon className="w-5 h-5 text-red-500/70 shrink-0 mt-0.5" data-id="element-322" />
                    <span className="leading-relaxed" data-id="element-323">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}